export default {"src":"/_next/static/media/telegram-solid.47e940e7.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};